module.exports = __webpack_public_path__ + "img/IND-i-2-III.e0806dd6.png";